<template lang="html">
  <div class="container-visualizacao-sla" v-if="this.$store.state.contrato.itensContrato.contrato_id && this.$store.state.fornecedor.dadosFornecedor !== null">
    <div class="box box-primary">
      <vue-position-sticky class="ajusta-cabecalho-impressao">
        <div class="sticky">
          <div class="box-header with-border desabilitar-impressao">
            <b-button variant="primary" @click="exibeModalAdicionarEvidencia">Adicionar evidência</b-button>
            <b-button variant="primary evidencia-retencao" @click="exibeModalAdicionarGlosa" v-if="this.$store.state.contrato.itensContrato.tipo_contrato_id != 3 && this.$store.state.contrato.itensContrato.tipo_contrato_id != 4">Adicionar evidência de glosa</b-button>
          </div>
          <div class="box-body">
            <div class="text-center desabilitar-impressao">
              <h4><strong>CONTROLE E APURAÇÃO DE SLA</strong></h4>
            </div>
            <div class="row" align="center">
              <div class="col-md-6 label-cabecalho">
                <label class="label-cabecalho">Fornecedor:&nbsp;</label>
                {{ typeof cabecalho_sla.fornecedor !== "undefined" ? cabecalho_sla.fornecedor : '' }}
              </div>
              <div class="col-md-6 label-cabecalho">
                <label class="label-cabecalho">Nº Contrato:&nbsp;</label>
                {{ typeof cabecalho_sla.numero_contrato_original !== "undefined" ? cabecalho_sla.numero_contrato_original : '' }}
              </div>
              <div class="col-md-6 label-cabecalho">
                <label class="label-cabecalho">Natureza:&nbsp;</label>
                {{ typeof cabecalho_sla.natureza !== "undefined" ? cabecalho_sla.natureza : '' }}
              </div>
              <!-- <div class="col-md-6 label-cabecalho">
                <label class="label-cabecalho">Valor Mensal:&nbsp;</label>
                {{ typeof cabecalho_sla.valor_mensal_contrato !== "undefined" ? cabecalho_sla.valor_mensal_contrato : ''}}
              </div> -->
            </div>
          </div>
        </div>
        <!-- Editar Aqui -->
        <div class="sticky descricao">
          <div class="table-responsive">
            <table class="table table-bordered table-condensed table-hover" border="1">
              <thead>
                <tr class="desabilitar-impressao">
                  <th id="item">ITEM</th>
                  <th id="descricao" align="center" class="text-center" colspan="15">DESCRIÇÃO</th>
                </tr>
              </thead>
            </table>
          </div>
        </div>
      </vue-position-sticky>

      <div class="table-responsive">
        <table class="table table-bordered table-condensed table-hover" border="1">
          <tbody v-for="item in itens_sla">
            <tr>
              <td class="numero-item bg-color-extremidades alinhar-conteudo fonte-tabela" rowspan="7"> {{ item.numero_item }}</td>
              <td class="descricao-sla bg-color-extremidades fonte-tabela" colspan="25">{{ item.descricao }}</td>
            </tr>
            <tr>
              <td class="detalhe-descricao fonte-tabela" colspan="15">{{ item.detalhamento_descricao }}</td>
            </tr>
            <tr>
              <td class="fonte-color-unidade-medicao fonte-tabela" colspan="4">{{ item.unidade_medicao_tipo }}</td>
              <td class="alinhar-conteudo fonte-color-unidade-medicao fonte-tabela"><strong>{{ item.peso_item }}</strong></td>
              <td class="fonte-color-unidade-medicao fonte-tabela" colspan="9">
                Pontos - Inicia com 10 pts / perde {{ item.peso_item }} {{ item.texto_taxa }}
              </td>
            </tr>
            <tr>
              <td class="meta-pontuacao fonte-tabela">Meta de pontuação</td>
              <td class="meta-pontuacao-valor alinhar-conteudo fonte-tabela">{{ item.meta_pontuacao }}</td>
              <td class="meses alinhar-conteudo fonte-tabela" v-for="mes in meses"><strong>{{ mes.sigla }}</strong></td>
            </tr>
            <tr>
              <td class="nao-conformidades fonte-tabela" colspan="2">Qtde de não-conformidades</td>
              <td class="meses alinhar-conteudo fonte-tabela" v-for="mes in item.quantidade_apurada.mes">

                <a v-on:click="listarEvidenciaAtual(mes.evidencias)" v-if="mes.total_nao_conformidades != 0 || existeEvidenciasAnuladas(mes.evidencias)" href="javascript:void(0)" data-toggle="modal" data-target="#listarEvidencias">
                  {{ mes.total_nao_conformidades }}
                </a>
                <span v-else>{{ mes.total_nao_conformidades }}</span>

              </td>
            </tr>
            <tr>
              <td class="pontuacao-alcada fonte-tabela" colspan="2">Pontuação alcançada</td>
              <td class="meses alinhar-conteudo fonte-tabela" v-for="mes in item.quantidade_apurada.mes">
                {{ mes.pontuacao_alcancada }}
              </td>
            </tr>
            <tr>
              <td class="multa fonte-tabela" colspan="2">% multa</td>
              <td class="meses alinhar-conteudo fonte-tabela" v-for="mes in item.quantidade_apurada.mes">
                {{ mes.multa }}
              </td>
            </tr>
            <tr>
              <td class="fonte-tabela exibicao-evidencias-por-mes" colspan="15">
                <exibir-evidencia-impressao :evidencia="item.quantidade_apurada.mes" />
              </td>
            </tr>
          </tbody>
          <!-- Cálculos rodapé tabela -->
          <tbody class="ajusta-resultado-calculo-impressao">
            <tr>
              <td class="percentual-multa-periodo bg-color-calculo-total-sla" colspan="3">Percentual de Multa no período (%)</td>
              <td class="bg-color-calculo-total-sla text-center" v-for="percentual in percentual_multa_periodo">
                {{ percentual }}
              </td>
            </tr>
            <tr>
              <td class="valor-mensal-contrato bg-color-calculo-total-sla" colspan="3">Valor Mensal do Contrato</td>
              <td class="valor-contrato bg-color-calculo-total-sla text-center" v-for="valor_mensal in valor_mensal_contrato">
                {{ valor_mensal.moeda }}
              </td>
            </tr>
            <tr>
              <td class="valor-multa bg-color-calculo-total-sla" colspan="3">Valor da multa (R$)</td>
              <td class="bg-color-calculo-total-sla text-center" v-for="multa in valor_multa">
                {{ multa.moeda }}
              </td>
            </tr>
            <tr>
              <td class="valor-multa-utilizado-extra-mensal bg-color-calculo-total-sla" colspan="3">Valor multa utilizado - Extra Mensal</td>
              <td class="bg-color-calculo-total-sla text-center" v-for="multa_extra in multa_extra_mensal">
                {{ multa_extra.moeda }}
              </td>
            </tr>
            <tr>
              <td class="valor-multa-a-ser-aplicada bg-color-calculo-total-sla" colspan="3">Valor da multa a ser aplicada (R$)</td>
              <td class="valor-contrato text-center" v-for="multa_aplicada in valor_multa_aplicada">
                {{ multa_aplicada.moeda }}
              </td>
            </tr>
            <tr>
              <td class="indice-performance bg-color-calculo-total-sla" colspan="3">Índice de performance</td>
              <td class="bg-color-calculo-total-sla text-center" v-for="performance in indice_performance">
                {{ performance }}
              </td>
            </tr>
          </tbody>
        </table>

        <!-- tabela laranja -->
        <table-glosa-evidencia v-if="this.$store.state.contrato.itensContrato.tipo_contrato_id != 3 && this.$store.state.contrato.itensContrato.tipo_contrato_id != 4" :contrato="contrato" :fornecedor="(this.$store.state.fornecedor.dadosFornecedor.fornecedor_id !== '-- Selecionar Fornecedor --') ? this.$store.state.fornecedor.dadosFornecedor.fornecedor_id : null" :ano="anoSelecionado" />
        <!-- resumo mensal -->
        <table-fechamento-multa-glosa :contrato="contrato" :ano="anoSelecionado" :uf="ufIdSelecionada" :fornecedor="(this.$store.state.fornecedor.dadosFornecedor.fornecedor_id !== '-- Selecionar Fornecedor --') ? this.$store.state.fornecedor.dadosFornecedor.fornecedor_id : null" :multas="valor_multa" />

      </div>
    </div>
    <div class="grupo-botoes-rodape desabilitar-impressao">
      <button class="btn btn-historico btn-default desabilitar-impressao" variant="primary" data-toggle="modal" v-on:click="listarHistoricoSla()" data-target="#modalHistoricoSla">Histórico</button>
      <exportar-sla />
    </div>
  </div>
  <div v-else-if="semresultado !== null" class="sem-contrato">
    <p><strong>Não foi encontrado contrato com os filtros selecionados</strong></p>
    <p>Selecione estado e contrato</p>
  </div>
  <div v-else class="sem-contrato">
    <p>Selecione estado e contrato</p>
  </div>
</template>

<script>
import exibirEvidenciaImpressao from '../evidencia/print/EvidenciaImpressao.vue'
import exportarSla from './exportarSla/Index.vue'
import TableGlosaEvidencia from '../glosa/table/TableGlosaEvidencia.vue'
import tableFechamentoMultaGlosa from './table/TableFechamentoMultaGlosa.vue'

export default {
  props: ['refresh_componentes', 'anoSelecionado', 'semresultado'],
  data() {
    return {
      items: [],
      ufIdSelecionada: '',
      tipoImovelServicoSelecionado: [],
      cabecalho_sla: [],
      itens_sla: [],
      percentual_multa_periodo: [],
      valor_mensal_contrato: [],
      valor_multa: [],
      valor_multa_aplicada: [],
      multa_extra_mensal: [],
      indice_performance: [],
      numero_contrato_original: '',
      contrato: [],
      meses: [],
      env: process.env,
      refreshEvidenciaAtual: '',
      listarEvidenciasPorItem: [],
      dadosFechamentoSla: []
    }
  },
  components: {
    'exibir-evidencia-impressao': exibirEvidenciaImpressao,
    'exportar-sla': exportarSla,
    'table-glosa-evidencia': TableGlosaEvidencia,
    'table-fechamento-multa-glosa': tableFechamentoMultaGlosa
  },
  methods: {
    getSla(ufSelecionada, contratoSelecionado) {
      this.ufIdSelecionada = ufSelecionada
      this.tipoImovelServicoSelecionado = contratoSelecionado
      let formData = new FormData()
      let vm = this
      this.$store.commit('setContrato', 0)
      formData.append('uf_id', ufSelecionada)
      formData.append('tipo_contrato_id', contratoSelecionado.tipo_contrato_id)
      formData.append('tipo_imovel_contrato_id', contratoSelecionado.tipo_imovel_contrato_id)
      formData.append('tipo_imovel_servico_id', contratoSelecionado.id)
      formData.append('ano_selecionado', this.$store.state.ano.ano_selecionado)
      formData.append('fornecedor_id', this.$store.state.fornecedor.dadosFornecedor.fornecedor_id)
      formData.append('contrato_id', this.$store.state.fornecedor.dadosFornecedor.contrato_id)

      this.$axios.post(`${this.env.FINANCEIRO.SLA}/getslas`, formData, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      }).then(function (response) {
        if (response.data.sla.hasOwnProperty('itens_sla')) {
          // console.warn('retorno', response.data)
          vm.itens_sla = response.data.sla.itens_sla
          vm.meses = response.data.sla.meses
          vm.numero_contrato_original = response.data.sla.contrato.numero_contrato_original
          vm.percentual_multa_periodo = response.data.sla.percentual_multa_periodo
          vm.valor_mensal_contrato = response.data.sla.valor_mensal_contrato
          vm.contrato = response.data.sla.contrato
          vm.valor_multa = response.data.sla.multa
          vm.multa_extra_mensal = response.data.sla.multa_extra_mensal
          vm.valor_multa_aplicada = response.data.sla.multa_aplicada
          vm.indice_performance = response.data.sla.indice_performance
          vm.formatarCabecalhoSla([response.data.sla])
          vm.$store.commit('setItensSla', response.data.sla)
          vm.$store.commit('setContrato', response.data.sla.contrato)
          vm.semresultado = null
        } else {
          vm.semresultado = true
          console.log('Não foi encontrado contrato com esse filtro')
        }
      }).catch(function (e) {
        vm.semresultado = null
        console.log('Algo de errado com a requisição getSlas!')
      })
    },
    formatarCabecalhoSla(itensSla) {
      let vm = this
      let mapa = itensSla
      mapa.map(item => {
        vm.cabecalho_sla = {
          fornecedor: item.fornecedor.sigla,
          natureza: item.contrato.tipo_imovel_servico,
          numero_contrato_original: item.contrato.numero_contrato_original,
          valor_mensal_contrato: item.contrato.valor_mensal_contrato
        }
      })
    },
    listarHistoricoSla() {
      let vm = this
      this.$axios.get(`${this.env.FINANCEIRO.SLA}/gethistorico/${vm.$store.state.contrato.itensContrato.contrato_id}`, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      }).then(function (response) {
        let promises = response.data.map(item => {
          return {
            'usuário': item.usuario,
            'item_SLA': item.numero_item,
            'mês': item.mes,
            'ano': item.ano,
            'ação': item.acao,
            'alterado_em': item.data
          }
        })
        Promise.all(promises).then(function (evidenciasFormatadas) {
          vm.$store.commit('setHistoricoSla', evidenciasFormatadas)
        })
      }).catch(function (e) {
        console.log('Algo de errado com a busca de histórico!')
      })
    },
    listarEvidenciaAtual(evidenciasAtuais) {
      let consultaEvidenciaPorMes = { contrato_id: evidenciasAtuais[0].contrato_id, item_sla_id: evidenciasAtuais[0].item_sla_id, mes_id: evidenciasAtuais[0].mes_id, ano_selecionado: this.anoSelecionado }
      this.$store.commit('setEvidenciasPorMes', consultaEvidenciaPorMes)
    },
    existeEvidenciasAnuladas: function (evidencias) {
      if (evidencias === null) {
        return 0
      }
      let existeAnulado = evidencias.filter(item => {
        return item.anulado === 1
      })
      return existeAnulado.length ? 1 : 0
    },
    exibeModalAdicionarEvidencia: function () {
      this.$store.commit('setAdicionarEvidencia', { conteudo: null, show: true })
    },
    exibeModalAdicionarGlosa: function () {
      this.$store.commit('setAdicionarGlosa', { conteudo: null, show: true })
    }
  }
}
</script>
<style scoped src="./css/controleApuracaoSla.css"></style>



// WEBPACK FOOTER //
// ControleApuracaoSla.vue?2cef978c